<script setup lang="ts">
  import type { Benchmark } from '~/generated/api-clients-generated'

  const props = defineProps<{
    id: string
    benchmark: Benchmark
  }>()

  const { getComponentContent } = Cms.use()
  const { content } = await getComponentContent('PlanBenchmark')

  const badgeVariant = computed(
    () => content.value?.data?.tones?.[_snakeCase(props.benchmark.tone)]
  )
  const textTemplate = computed(
    () => content.value?.data?.[_snakeCase(props.id)]?.[_snakeCase(props.benchmark.tag)]
  )
  const renderedText = computed(() =>
    Object.keys(props.benchmark.data ?? {}).reduce(
      (previousValue, currentValue) =>
        previousValue.replaceAll(
          `{{${currentValue}}}`,
          (props.benchmark.data ?? {})?.[currentValue]
        ),
      textTemplate.value
    )
  )
</script>

<template>
  <QuoteBadge :variant="badgeVariant" small>
    {{ renderedText }}
  </QuoteBadge>
</template>

<style scoped></style>
